<template>
  <div class="h5-home">
    <img class="h5-background" src="./images/h5-home.png" alt="" />
    <a
      class="service-support"
      href="https://open.work.weixin.qq.com"
      target="_blank"
    >
      <img
        src="https://open.work.weixin.qq.com/service/img?id=ww78cdbaf1a5ff313e&t=isp&c=white&s=medium"
        srcset="
          https://open.work.weixin.qq.com/service/img?id=ww78cdbaf1a5ff313e&t=isp&c=white&s=medium@2x 2x
        "
        referrerpolicy="unsafe-url"
        alt="企业微信"
      />
    </a>
    <div class="wework-install">
      <a
        href="https://open.work.weixin.qq.com/wwopen/appUrl/921600"
        target="_blank"
      >
        <img height="30" :src="weInstallImg" />
      </a>
      <div class="item">
        <!-- <img height="30" :src="registerWeworkImg" @click="registerWework" /> -->
      </div>
    </div>
  </div>
</template>
<script>
import weInstallImg from './images/channel/weixin_install_small.png'
import registerWeworkImg from './images/channel/weixin_register_small.png'
export default {
  name: 'HomeMobile',
  data() {
    return {
      weInstallImg,
      registerWeworkImg,
    }
  },
  methods: {
    async registerWework() {
      const baseUrl = 'https://yzcweixin.niimbot.com/customer/api'
      try {
        const { data } = await fetch(
          `${baseUrl}/weixin/auth/registerCode`
        ).then((res) => res.json())
        const url = `https://open.work.weixin.qq.com/3rdservice/wework/register?register_code=${data.register_code}#/pc`
        window.open(url, '_blank')
      } catch (e) {
        this.$message.error('出错了，请您稍后再试~')
      }
    },
  },
}
</script>
<style scoped>
.h5-home {
  position: relative;
}
.h5-background {
  width: 100%;
}
.service-support {
  position: absolute;
  top: 2%;
  left: 6.5%;
  z-index: 1;
}
.wework-install {
  display: flex;
  position: absolute;
  top: 10.5%;
  left: 6.5%;
}
.item {
  margin-left: 5%;
}
</style>



// WEBPACK FOOTER //
// src/components/HomeMobile.vue